import { Routes } from '@angular/router';
import { concursoRoutes } from './features-modules/gestao-de-concurso/concurso.routes';
import { profissionaisRoutes } from './features-modules/bolsa-de-profissionais/profissionais.routes';
import { gestaoBolseirosRoutes } from './features-modules/gestao-bolseiros/gestao-bolseiros.routes';
import { DashboardComponent } from './features-modules/dashboard/dashboard.component';
import { AddRepresentanteComponent } from './features-modules/gestao-bolseiros/components/instituicoes-ensino/add-representante/add-representante.component';
import { HomeReportComponent } from './features-modules/reports/home-report/home-report.component';
import { ConfigurationRoutes } from './features-modules/configuracoes/configuracoes.routes';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full', // redirect to `first-component`
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
  },
  {
    path: 'relatorios',
    component: HomeReportComponent
  },
  {
    path: 'gestao-bolseiros',
    // component: MainGestaoBolseirosComponent,
    children: [...gestaoBolseirosRoutes],
  },
  {
    path: 'gestao-concurso',
    children: [...concursoRoutes],
  },
  {
    path: 'bolsa-profissionais',
    children: [...profissionaisRoutes],
  },
  {
    path: 'configuracoes',
    children: [...ConfigurationRoutes],
  },
  {
    path: 'add-representante',
    component: AddRepresentanteComponent,
  },
];
